import { memo, useEffect, useRef, useState } from "react";
import { Col, Form, Image, OverlayTrigger, Tooltip } from "react-bootstrap"
import { Alarm, Award, AwardFill, LightningFill } from "react-bootstrap-icons";
import { v4 as uuidv4 } from "uuid";
import { PLAYER_CONFIG, PLAYER_CONFIG_TIP } from "../constants/Common";

const MoleculeImageInputNumber = ({ img, priority, value, cbOnChange, cbOnChangePriority, min = 0 }) => {
    const uniqueId = uuidv4()
    const [tempValue, setTempValue] = useState(0);
    useEffect(() => {
        setTempValue(value ?? min);
    }, [value])

    return (
        <Col className="text-center mb-3">
            <Form.Group controlId={uniqueId} className="align-items-center justify-content-center">
                {/* Icon Info với Tooltip */}
                <Form.Label className="ms-4">
                    <Image
                        src={img}
                        rounded
                        fluid
                        width="75%"
                    />
                </Form.Label>
                <div className="d-flex flex-row align-items-center justify-content-center mb-1">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>{PLAYER_CONFIG_TIP[PLAYER_CONFIG.ID_PRIORITY_HAI_SAN]}</Tooltip>}
                    >
                        <Alarm color="red" size={32} className="me-2" />
                    </OverlayTrigger>
                    <Form.Select
                        // style={{ width: "50%" }}
                        value={priority}
                        onChange={(e) => {
                            if (cbOnChangePriority != null) cbOnChangePriority(e.target.value);
                        }}>
                        <option value="0">1</option>
                        <option value="1">2</option>
                        <option value="2">3</option>
                        <option value="3">4</option>
                        <option value="4">5</option>
                        <option value="5">6</option>
                    </Form.Select>
                </div>
                <div className="d-flex  flex-row align-items-center justify-content-center">
                    <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Số lượng tổng mong muốn</Tooltip>}
                    >
                        <Award color="green" size={32} className="me-2" />
                    </OverlayTrigger>
                    <Form.Control
                        type="text" // Đổi từ number sang text
                        inputMode="numeric" // Để trình duyệt hiển thị bàn phím số
                        // style={{ width: "50%" }}
                        value={tempValue}
                        min={min}
                        onChange={(e) => {
                            const newValue = e.target.value.replace(/[^0-9]/g, ""); // Chỉ cho phép nhập số
                            if (newValue === "") setTempValue(min)
                            else setTempValue(Number(newValue))
                        }}
                        onBlur={(e) => {
                            cbOnChange(e.target.value);
                        }}
                    />
                </div>
            </Form.Group>
        </Col>
    )
}

export default memo(MoleculeImageInputNumber)